import React, { useState } from 'react'
import { createDataModel } from '../../../../store/model/api'
import { ButtonLighth } from '../../../Atoms/Buttons/ButtonLighth'
import { ButtonSmall } from '../../../Atoms/Buttons/ButtonSmall'
import { TextInput } from '../../../Atoms/Inputs/Text'
import { toast } from 'react-toastify'
import { handleError } from '../../../../utils/handleErrors'
import s from './CreateNewDataPopup.module.scss'

export const CreateNewDataPopup = ({
    isOpen,
    setShowPopup,
    closePopUp,
    state,
    setState,
    setStateDataModel,
    stateDataModel,
    dataModelsList,
}) => {
    const [dataModelName, setDataName] = useState('')
    const handleCreateData = () => {
        setShowPopup(false)
        createDataModel(dataModelName)
            .then((createData) => {
                if (createData) {
                    setStateDataModel([createData, ...stateDataModel])
                    toast.success('Successfully Created')
                }
            })
            .catch(handleError)
    }
    return (
        <div className={s.popupWrapper}>
            <div className={s.popupBox}>
                <div className={s.popupHeader}>
                    <div className={s.popupName}>Create New Data</div>
                    <div className={s.popupX}>
                        <img
                            onClick={closePopUp}
                            src="/assets/images/popupX.png"
                            alt="close"
                        />
                    </div>
                </div>

                <div className={s.popupForm}>
                    <div className={s.popupFormItem}>
                        <TextInput
                            label="Data Model"
                            placeholder="Data Model"
                            value={dataModelName}
                            onChange={({ target }) => {
                                setDataName(target.value)
                            }}
                        />
                    </div>
                </div>

                <div className={s.popupButtonsWrapper}>
                    <ButtonLighth onClick={closePopUp} value="Cancel" />
                    <ButtonSmall onClick={handleCreateData} value="Create" />
                </div>
            </div>
        </div>
    )
}
